export default class I18nMissing {
  constructor(props) {
    this.translations = {}
  }
  t(key) {
    throw new Error('I18n is missing')
  }
  l(date) {
    throw new Error('I18n is missing')
  }
}
